import { gsap } from "gsap";


export default class Accordion {
	constructor(el) {
		this.segments = el.querySelectorAll('[data-accordion-segment]');
		this.accordionSegments = new Map();

		this.segments.forEach(segment => {
			const accordionSegment = new AccordionSegment(segment);
			this.accordionSegments.set(segment, accordionSegment);
		});
	}
}


class AccordionSegment {
	constructor(el) {
		this.el = el;
		this.button = this.el.querySelector('[data-accordion-button]');
		this.target = this.el.querySelector(this.button.dataset.accordionButton);

		if(!this.target) {
			return;
		}

		// Status
		this.isOpen = false;
		this.isAnimating = false;

		// Event listeners
		this.button.addEventListener('click', this.toggle.bind(this));
		this.events = [];
	}

	toggle() {
		if (this.isAnimating) {
			return;
		}

		this.isOpen ? this.close() : this.open();
	}

	open() {
		if (this.isOpen) {
			return;
		}
		this.isAnimating = true;
		this.button.setAttribute('aria-expanded', true);

		return new Promise(resolve => {
			const item = this.target;

			gsap.set(item, {
				opacity: 0,
				display: 'block'
			});

			const height = item.scrollHeight;

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 'auto',
					});

					this.isOpen = true;
					this.isAnimating = false;

					resolve();
				}
			});

			tl.to(item, {
				height: height,
				duration: 0.2,
				ease: 'sine.inOut',
			});
			tl.to(item, {
				opacity: 1,
				duration: 0.1,
				ease: 'none',
			});
		});
	}

	close() {
		if (!this.isOpen) {
			return;
		}
		this.isAnimating = true;
		this.button.setAttribute('aria-expanded', false);

		return new Promise(resolve => {
			const item = this.target;

			gsap.set(item, {
				height: item.scrollHeight,
			});

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 0,
						display: 'none'
					});

					this.isOpen = false;
					this.isAnimating = false;

					resolve();
				}
			});

			tl.to(item, {
				opacity: 0,
				duration: 0.1,
				ease: 'none',
			});
			tl.to(item, {
				height: 0,
				duration: 0.2,
				ease: 'sine.inOut',
			});
		});
	}
}